export const entregaStatus = {
    EM_ABERTO: 0,
    EM_APROVACAO: 1,
    APROVADA: 2,
    REPROVADA: 3,
    EXCLUIDA: 4,
    PENDENCIA_SAS: 5,
    CANCELADA_SEM_PAGAMENTO: 6,
    CANCELADA_COM_PAGAMENTO: 7,
    EM_APROVACAO_GERENTE: 8
}
